import { render, staticRenderFns } from "./anonymousDialog.vue?vue&type=template&id=1dbedfa6&scoped=true"
import script from "./anonymousDialog.vue?vue&type=script&lang=js"
export * from "./anonymousDialog.vue?vue&type=script&lang=js"
import style0 from "./anonymousDialog.vue?vue&type=style&index=0&id=1dbedfa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbedfa6",
  null
  
)

export default component.exports